import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets scroll to top whenever the route changes. React Router doesn't
// do this by default; without it, navigating to /contact from the bottom
// of /services lands you at the bottom of /contact.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
